import React from 'react';
import Icon from 'components/AppIcon';

const stats = [
  { label: 'Total Accounts', value: 1248, icon: 'Users', color: 'text-blue-600', bg: 'bg-blue-50' },
  { label: 'Distributors', value: 84, icon: 'Truck', color: 'text-violet-600', bg: 'bg-violet-50' },
  { label: 'Retail Stores', value: 763, icon: 'Store', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { label: 'Dealers', value: 241, icon: 'Briefcase', color: 'text-amber-600', bg: 'bg-amber-50' },
  { label: 'Sub-Distributors', value: 160, icon: 'Network', color: 'text-rose-600', bg: 'bg-rose-50' },
  { label: 'Credit Utilized', value: '₱42.3M', icon: 'CreditCard', color: 'text-indigo-600', bg: 'bg-indigo-50' },
  { label: 'Active This Month', value: 1102, icon: 'Activity', color: 'text-teal-600', bg: 'bg-teal-50' },
  { label: 'Coverage %', value: '88.3%', icon: 'MapPin', color: 'text-orange-600', bg: 'bg-orange-50' },
];

const regionDist = [
  { region: 'NCR', count: 312, pct: 25 },
  { region: 'Luzon', count: 487, pct: 39 },
  { region: 'Visayas', count: 261, pct: 21 },
  { region: 'Mindanao', count: 188, pct: 15 },
];

export default function AccountStatsPanel() {
  return (
    <div className="space-y-4">
      {/* KPI Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {stats?.map((stat) => (
          <div key={stat?.label} className="card kpi-card-glow p-4">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${stat?.color}18` }}>
                <Icon name={stat?.icon} size={16} color={stat?.color} strokeWidth={2} />
              </div>
              <span className="font-caption text-sm font-medium" style={{ color: '#475569' }}>{stat?.label}</span>
            </div>
            <p className="font-heading text-xl font-bold" style={{ color: '#0F172A' }}>{stat?.value}</p>
            {stat?.sub && <p className="font-caption text-xs mt-0.5" style={{ color: '#94A3B8' }}>{stat?.sub}</p>}
          </div>
        ))}
      </div>
      {/* Territory Distribution */}
      <div className="bg-card border border-border rounded-lg p-4">
        <h3 className="font-heading text-sm font-semibold text-foreground mb-3">Territory Distribution</h3>
        <div className="space-y-2">
          {regionDist?.map((r) => (
            <div key={r?.region}>
              <div className="flex justify-between items-center mb-1">
                <span className="font-caption text-xs text-foreground">{r?.region}</span>
                <span className="font-data text-xs text-muted-foreground">{r?.count} ({r?.pct}%)</span>
              </div>
              <div className="h-1.5 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full"
                  style={{ width: `${r?.pct}%`, background: 'var(--color-primary)' }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Credit Utilization */}
      <div className="bg-card border border-border rounded-lg p-4">
        <h3 className="font-heading text-sm font-semibold text-foreground mb-3">Credit Utilization</h3>
        <div className="space-y-2">
          {[
            { label: 'Total Limit', value: '₱58.5M', pct: 100, color: 'bg-slate-200' },
            { label: 'Utilized', value: '₱42.3M', pct: 72, color: 'bg-amber-400' },
            { label: 'Available', value: '₱16.2M', pct: 28, color: 'bg-emerald-400' },
          ]?.map((c) => (
            <div key={c?.label} className="flex items-center gap-3">
              <div className={`w-2 h-2 rounded-full ${c?.color} flex-shrink-0`} />
              <span className="font-caption text-xs text-foreground flex-1">{c?.label}</span>
              <span className="font-data text-xs font-medium text-foreground">{c?.value}</span>
              <span className="font-caption text-xs text-muted-foreground w-8 text-right">{c?.pct}%</span>
            </div>
          ))}
        </div>
        <div className="mt-3 h-2 bg-muted rounded-full overflow-hidden flex">
          <div className="h-full bg-amber-400" style={{ width: '72%' }} />
          <div className="h-full bg-emerald-400" style={{ width: '28%' }} />
        </div>
      </div>
    </div>
  );
}